import React, { useState } from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField
  } from "@mui/material";
import Input from '../../../../../stories/Input/Input';
import { labelClasses, LabeledAutocomplete } from '../../../../../styles/AutocompleteStyles';
import { handleMUISelectEvent } from '../../../../../utils/UtilFunctions';
import { Keys } from '../../../../../utils/Enum.keys';
import ItemDetails from '../../purchase/stockbalance/ItemDetails';
import useAssetTableJson from '../../../../../json/useAssetTableJson';
import { StockEntryTable } from '../../purchase/stockentry/Add/Add';
import { TableHeaderProps } from '../../../../../utils/types';
import { Button } from '../../../../../stories/Button/Button';
import Calendar from "../../../../../images/Calendar.svg";
import CalendarBlack from "../../../../../images/CalendarBlack.svg"

const options = ["IT Equipment", "Tools and Machinery", "Softwares"];

const ViewAssetDetails = () => {
    const { Purchase } = useAssetTableJson();

    const [filterColumns, setFilterColumns] = useState(false);
    const [viewConfig, setViewConfig] = useState(false);
    const [locationDetails, setLocationDetails] = useState(false);
    const [columns, setColumns] = useState(Purchase.StockEntry.Add.SubHeader);
    const handleColumnToggle = (field: string) => {
      setColumns((prevColumns) =>
        prevColumns.map((col) => {
          if (
            field === StockEntryTable.Warranty &&
            (col.field === StockEntryTable.Warranty_Start_Date||
              col.field === StockEntryTable.Warranty_End_Date)
          ) {
            return { ...col, hideable: !col.hideable };
          } else if (
            field === StockEntryTable.Insurance &&
            (col.field === StockEntryTable.INC_Start_Date ||
              col.field === StockEntryTable.INC_end_Date)
          ) {
            return { ...col, hideable: !col.hideable };
          } else if (
            field === StockEntryTable.AMC &&
            (col.field === StockEntryTable.AMC_Start_Date ||
              col.field === StockEntryTable.AMC_End_Date)
          ) {
            return { ...col, hideable: !col.hideable };
          }
  
          return col.field === field ? { ...col, hideable: !col.hideable } : col;
        })
      );
    };
    const visibleColumns = columns.filter((col) => !col.hideable);
  return (
    <>

<ItemDetails />

          <div className="stock-balance-add__search row g-0">
          <div className="col-2">
            <Input id="data_search" placeholder="Search" />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={options}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Filter Stock Location"
                  slotProps={{
                    inputLabel: {
                      shrink: true
                    }
                  }}
                />
              )}
            />
          </div>
        </div>
        <div className="stock-balance-add__tableblock">
          <TableContainer className="stock-balance-add__table">
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {visibleColumns
                    .filter((th) =>
                      [
                        StockEntryTable.SL_No,
                        StockEntryTable.Serial_No,
                        StockEntryTable.Batch,
                        StockEntryTable.Expiry,
                        StockEntryTable.Maintained_By,
                        StockEntryTable.AMC_Enabled,
                        StockEntryTable.Geo_Location,
                        StockEntryTable.Stock_Location,
                        StockEntryTable.Warranty,
                        StockEntryTable.AMC,
                        StockEntryTable.Insurance
                      ].includes(th.field as StockEntryTable)
                    )
                    .map((th: TableHeaderProps, index: React.Key) => {
                      return (
                        <TableCell
                          key={index}
                          rowSpan={
                            [
                              StockEntryTable.SL_No,
                              StockEntryTable.Serial_No,
                              StockEntryTable.Batch,
                              StockEntryTable.Expiry,
                              StockEntryTable.Maintained_By,
                              StockEntryTable.AMC_Enabled,
                              StockEntryTable.Geo_Location,

                              StockEntryTable.Stock_Location
                            ].includes(th.field as StockEntryTable)
                              ? 2
                              : 1
                          }
                          colSpan={
                            [
                              StockEntryTable.Warranty,
                              StockEntryTable.AMC,
                              StockEntryTable.Insurance
                            ].includes(th.field as StockEntryTable)
                              ? 2
                              : 1
                          }
                        >
                          {th.headerName}
                        </TableCell>
                      );
                    })}
                </TableRow>
                <TableRow>
                  {visibleColumns
                    .filter((th) =>
                      [
                        StockEntryTable.Warranty_Start_Date,
                        StockEntryTable.Warranty_End_Date,
                        StockEntryTable.AMC_Start_Date,
                        StockEntryTable.AMC_End_Date,
                        StockEntryTable.INC_Start_Date,
                        StockEntryTable.INC_end_Date
                      ].includes(th.field as StockEntryTable)
                    )
                    .map((th: TableHeaderProps, index: React.Key) => {
                      return (
                        <>
                          <TableCell key={index}>{th.headerName}</TableCell>
                        </>
                      );
                    })}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  {visibleColumns.map((th: TableHeaderProps, index) => {
                    if (th.field === StockEntryTable.SL_No) {
                      return <TableCell id="td-center">{index + 1}</TableCell>;
                    } else if (th.field === StockEntryTable.Serial_No) {
                      return <TableCell>1 </TableCell>;
                    } else if (th.field === StockEntryTable.Batch) {
                      return <TableCell>batch </TableCell>;
                    } else if (th.field === StockEntryTable.Expiry) {
                      return (
                        <TableCell>
                          11-12-2024 <img src={Calendar} alt="" />{" "}
                        </TableCell>
                      );
                    } else if (th.field === StockEntryTable.Warranty_Start_Date) {
                      return (
                        <TableCell>
                          11-12-2024 <img src={CalendarBlack} alt="" />
                        </TableCell>
                      );
                    } else if (th.field === StockEntryTable.Warranty_End_Date) {
                      return (
                        <TableCell>
                          11-12-2024 <img src={Calendar} alt="" />
                        </TableCell>
                      );
                    } else if (th.field === StockEntryTable.Maintained_By) {
                      return <TableCell></TableCell>;
                    } else if (th.field === StockEntryTable.AMC_Enabled) {
                      return <TableCell></TableCell>;
                    } else if (th.field === StockEntryTable.AMC_Start_Date) {
                      return (
                        <TableCell>
                          11-12-2024 <img src={CalendarBlack} alt="" />
                        </TableCell>
                      );
                    } else if (th.field === StockEntryTable.AMC_End_Date) {
                      return (
                        <TableCell>
                          11-12-2024 <img src={Calendar} alt="" />
                        </TableCell>
                      );
                    } else if (th.field === StockEntryTable.Geo_Location) {
                      return <TableCell></TableCell>;
                    } else if (th.field === StockEntryTable.INC_Start_Date) {
                      return (
                        <TableCell>
                          11-12-2024 <img src={CalendarBlack} alt="" />
                        </TableCell>
                      );
                    } else if (th.field === StockEntryTable.INC_end_Date) {
                      return (
                        <TableCell>
                          11-12-2024 <img src={Calendar} alt="" />
                        </TableCell>
                      );
                    } else if (th.field === StockEntryTable.Stock_Location) {
                      return <TableCell>Hennur</TableCell>;
                    } else return null;
                  })}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
          <Button mode="back"  />
    </>
  )
}

export default ViewAssetDetails
